import { Subscription } from 'rxjs';
import { unsubscribeAll } from '../../../../common/app.helpers';
import { FieldAttribute } from '../../../../interfaces/form-and-field.interface';
import { MapSearchBlockContent } from '../../../../interfaces/map.interface';
import { MapValues } from '../../map.values';

export interface SearchBlockContentProviderI {
  emitSearchFormContent(): void;
}

export interface FieldVisibilityOptions {
  hidden?: boolean;
  disabled?: boolean;
}

type FieldNamesWithControlledVisibility = 'diseases' | 'specialties' | 'charity_focuses' | 'roles';

type FieldsVisibilityOptions = {
  [Property in FieldNamesWithControlledVisibility]?: FieldVisibilityOptions;
};

export abstract class SearchBlockContentStrategy implements SearchBlockContentProviderI {
  public subscriptions: Subscription[] = [];

  protected constructor(public mapSearchBlockContent: MapSearchBlockContent) {}

  public abstract emitSearchFormContent(): void;

  public get fieldAttributes(): FieldAttribute[] {
    return this.mapSearchBlockContent.formContent.fieldAttributes;
  }

  public getFieldIndex(backendAttributeMame: string): number {
    const attrs: FieldAttribute[] = this.fieldAttributes;
    return attrs.findIndex((metadata: FieldAttribute) => metadata.backendAttribute.name === backendAttributeMame);
  }

  public unsubscribeFromSearchBlockFieldChanges(): void {
    unsubscribeAll(this.subscriptions);
  }

  protected updateFieldsVisibility(options: FieldsVisibilityOptions): void {
    const attrs: FieldAttribute[] = this.fieldAttributes;
    const diseasesFieldIndex: number = this.getFieldIndex(MapValues.diseasesFieldName);
    const specialitiesFieldIndex: number = this.getFieldIndex(MapValues.specialtiesFieldName);
    const rolesFieldIndex: number = this.getFieldIndex(MapValues.rolesFieldName);
    const charityFocuses: number = this.getFieldIndex(MapValues.charityFocus);

    attrs[diseasesFieldIndex].hidden = options.diseases ? Boolean(options.diseases.hidden) : false;
    attrs[diseasesFieldIndex].disabled = options.diseases ? Boolean(options.diseases.disabled) : false;
    attrs[specialitiesFieldIndex].disabled = options.specialties ? Boolean(options.specialties.disabled) : false;

    attrs[charityFocuses].hidden = options.charity_focuses ? Boolean(options.charity_focuses.hidden) : false;
    attrs[charityFocuses].disabled = options.charity_focuses ? Boolean(options.charity_focuses.disabled) : false;

    if (rolesFieldIndex !== -1) {
      attrs[rolesFieldIndex].hidden = options.roles ? Boolean(options.roles.hidden) : false;
    }
  }
}
